import React from "react";
import { Cherry, Gem, CircleDollarSign, Flame, Crown, Star } from "lucide-react";
import { TbNumber7 } from "react-icons/tb";

/**
 * 5-SlotBET Game Configuration
 */
export const FIVE_SLOT_CONFIG = {
  name: "5-SLOTBET",
  reels: 5,
  rows: 3,
  paylines: 1,
  paylineDescription: "Match 3 or more symbols left-to-right on the center payline",
  initialReels: ["cherry", "coin", "bar", "diamond", "seven"],
};

export const THEME_OPTIONS = [
  {
    id: "classic_crypto_5r",
    label: "5-Reel Vegas & Crypto",
    description: "5-reel progressive pokies with Mini, Major, and Mega jackpot pools.",
  },
];

export const SYMBOLS = [
  {
    id: "cherry",
    symbol: (
      <Cherry
        size="1em"
        strokeWidth={2}
        style={{ transform: "translateY(-15%)" }}
      />
    ),
    iconText: "🍒",
    label: "Cherry",
    multiplier: "MINI JACKPOT",
    tier: "Mini Jackpot",
    tierColor: "#ef4444",
    payout: "Mini Jackpot",
    jackpotTier: "mini",
  },
  {
    id: "coin",
    symbol: <CircleDollarSign size="1em" strokeWidth={2} />,
    iconText: "🪙",
    label: "Coin",
    multiplier: "10x",
    tier: "Small Win",
    tierColor: "#3b82f6",
    payout: "Small Win",
  },
  {
    id: "bar",
    symbol: "BAR",
    iconText: "BAR",
    label: "BAR",
    multiplier: "25x",
    tier: "Medium Win",
    tierColor: "#6366f1",
    payout: "Medium Win",
  },
  {
    id: "diamond",
    symbol: <Gem size="1em" strokeWidth={2} />,
    iconText: "💎",
    label: "Diamond",
    multiplier: "MAJOR JACKPOT",
    tier: "Major Jackpot",
    tierColor: "#8b5cf6",
    payout: "Major Jackpot",
    jackpotTier: "major",
  },
  {
    id: "seven",
    symbol: <TbNumber7 size="1.2em" strokeWidth={2} />,
    iconText: "7️⃣",
    label: "Seven",
    multiplier: "MEGA JACKPOT",
    tier: "Mega Jackpot",
    tierColor: "#f59e0b",
    payout: "MEGA JACKPOT",
    jackpotTier: "mega",
  },
  {
    id: "crown",
    symbol: <Crown size="1em" strokeWidth={2} />,
    iconText: "👑",
    label: "Crown",
    multiplier: "50x",
    tier: "Big Win",
    tierColor: "#ec4899",
    payout: "Big Win",
  },
  {
    id: "wild",
    symbol: <Star size="1em" strokeWidth={2} />,
    iconText: "⭐",
    label: "Wild",
    multiplier: "WILD",
    tier: "Wild",
    tierColor: "#a855f7",
    payout: "Wild",
    isWild: true,
  },
  {
    id: "fire",
    symbol: <Flame size="1em" strokeWidth={2} />,
    iconText: "🔥",
    label: "Fire",
    multiplier: "15x",
    tier: "Hot Win",
    tierColor: "#f97316",
    payout: "Hot Win",
  },
];

export const getSymbolsByTheme = (themeName = "classic_crypto_5r") => {
  return SYMBOLS;
};

export const getRandomSymbol = () => {
  return SYMBOLS[Math.floor(Math.random() * SYMBOLS.length)];
};

export const getSymbolById = (id) => {
  return SYMBOLS.find((symbol) => symbol.id === id);
};

export const DUMMY_BET_CURRENCY = "BET";
export const REEL_COUNT = 5;
export const VISIBLE_ROWS = 3;

/** Stop timings (ms after spin start) — reels stop sequentially left to right */
export const REEL_STOP_TIMES = [700, 1100, 1500, 1900, 2300];
export const SPIN_TICK_MS = 80;
